var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAiaRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 4.5C17.5 3.67157 16.8284 3 16 3C15.1716 3 14.5 3.67157 14.5 4.5V14.5H4.5C3.67157 14.5 3 15.1716 3 16C3 16.8284 3.67157 17.5 4.5 17.5H14.5V27.5C14.5 28.3284 15.1716 29 16 29C16.8284 29 17.5 28.3284 17.5 27.5V17.5H27.5C28.3284 17.5 29 16.8284 29 16C29 15.1716 28.3284 14.5 27.5 14.5H17.5V4.5Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAiaRed);
export default __webpack_public_path__ + "static/media/add-aia-red.8a412abe0631372fa99e170e5168d6b4.svg";
export { ForwardRef as ReactComponent };